import { useMediaQuery, useTheme } from '@mui/material'
import { HiddenAttr } from '../screens/Admin/AdminAccounts'

const useHidden = (): (element: HiddenAttr | undefined) => boolean => {
  const theme = useTheme()
  const large = useMediaQuery(theme.breakpoints.up('lg'))
  const medium = useMediaQuery(theme.breakpoints.up('md'))
  const small = useMediaQuery(theme.breakpoints.up('sm'))
  const exLarge = useMediaQuery(theme.breakpoints.up('xl'))
  const exSmall = useMediaQuery(theme.breakpoints.up('xs'))

  return (element: HiddenAttr | undefined): boolean => {
    let size: boolean = exSmall
    if (element) {
      if (element === HiddenAttr.smUp) size = small
      if (element === HiddenAttr.mdUp) size = medium
      if (element === HiddenAttr.lgUp) size = large
      if (element === HiddenAttr.xlUp) size = exLarge
    }
    return size
  }
}

export default useHidden
